import classNames from 'classnames/bind'
import React, { KeyboardEvent } from 'react'
import * as styles from './style'
const cx = classNames.bind(styles)

export interface Props {
  id: string
  name: string
  checked?: boolean
  onChange: (checked: boolean) => void
  optionLabels: any
  small?: boolean
  disabled?: boolean
}

const ToggleSwitch = ({
  id,
  name,
  checked = false,
  onChange,
  optionLabels,
  small = false,
  disabled = false,
}: Props): JSX.Element => {
  const rootClasses = cx({
    root: true,
    small: small,
  })

  const innerClasses = cx({
    inner: true,
    disabled: disabled,
    checkedInner: checked,
  })

  const toggleClasses = cx({
    toggle: true,
    disabled: disabled,
    checkedToggle: checked,
  })

  function handleKeyPress(e: KeyboardEvent<HTMLLabelElement>): void {
    if (e.keyCode !== 32) return
    e.preventDefault()
    onChange(!checked)
  }

  return (
    <div className={rootClasses}>
      <input
        type="checkbox"
        name={name}
        className={styles.checkbox}
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        data-testid="checkbox"
      />
      {id ? (
        <label className={styles.label} tabIndex={disabled ? -1 : 1} onKeyDown={(e) => handleKeyPress(e)} htmlFor={id}>
          <span className={innerClasses} data-yes={optionLabels[0]} data-no={optionLabels[1]} tabIndex={-1} />
          <span className={toggleClasses} tabIndex={-1} />
        </label>
      ) : null}
    </div>
  )
}
export default ToggleSwitch
